import React from "react";

import { Box, BoxProps } from "../Box";

export type CardBodyProps = Omit<BoxProps, "flex">;

export const CardBody = (props: CardBodyProps) => (
  <Box p={3} {...props} flex={1} />
);
